import {
  AbsoluteWrapper,
  ArrowAbsoluteWrapper,
  ArrowWrapper,
  Container,
  Heading,
  MainBlockContainter,
  WavesImg,
} from "./styles";
import { DesktopBlocks } from "./Blocks";
import { textData as data } from "../../content/data/HomeData";
import { RefContext } from "../AppContext";
import React, { useContext } from "react";
import { CTAColor } from "../../styles/styles";
import ArrowBottom from "../../content/assets/ArrowBottom";
import useIsMobile from "../../common/hooks/useIsMobile";
import { scrollTo } from "../../common/func";
import { useScrollPos } from "../../common/hooks/scrollPosition";

const MainBlock = () => {
  const { introBlockRef, blocksRef } = useContext(RefContext);
  const isMobile = useIsMobile();
  const scrollPos = useScrollPos()

  return (
    <MainBlockContainter ref={introBlockRef}>
      {(isMobile && scrollPos < 164) ? (
        <ArrowAbsoluteWrapper onClick={() => scrollTo(blocksRef)}>
          <ArrowWrapper>
            <ArrowBottom color={CTAColor} />
          </ArrowWrapper>
        </ArrowAbsoluteWrapper>
      ) : null}
      <AbsoluteWrapper>
        <WavesImg
          src={require("../../content/assets/LinearWaves.png")}
          alt="waves"
        />
      </AbsoluteWrapper>
      <Container>
        <Heading>{data.header.title}</Heading>
      </Container>
      <DesktopBlocks />
    </MainBlockContainter>
  );
};

export default MainBlock;
